
import { showToast } from '/src/v4/toast.js';
import { showModal } from '/src/v4/modal.js';
import { openMenu } from '/src/v4/menus.js';

// Generic .tab handler — pill + underlined variants
document.addEventListener('click', (e) => {
  const tab = e.target.closest('.tab');
  if (!tab) return;
  tab.parentElement.querySelectorAll('.tab').forEach((t) => t.classList.remove('active'));
  tab.classList.add('active');
});

// Pagination demo
const pag = document.getElementById('demo-pagination');
if (pag) {
  pag.addEventListener('click', (e) => {
    const btn = e.target.closest('.page-btn');
    if (!btn || btn.disabled) return;
    e.stopPropagation();
    e.preventDefault();
    const allPages = pag.querySelectorAll('.page-btn[data-page]:not([data-page="prev"]):not([data-page="next"])');
    let activeIdx = Array.from(allPages).findIndex((b) => b.classList.contains('active'));
    if (btn.dataset.page === 'prev') activeIdx = Math.max(0, activeIdx - 1);
    else if (btn.dataset.page === 'next') activeIdx = Math.min(allPages.length - 1, activeIdx + 1);
    else activeIdx = Array.from(allPages).indexOf(btn);
    allPages.forEach((b) => b.classList.remove('active'));
    if (allPages[activeIdx]) allPages[activeIdx].classList.add('active');
    // Update prev/next disabled
    pag.querySelector('[data-page="prev"]').disabled = activeIdx === 0;
    pag.querySelector('[data-page="next"]').disabled = activeIdx === allPages.length - 1;
  });
}

// Rating stars
const rating = document.getElementById('rating-demo');
const ratingLabel = document.getElementById('rating-label');
function renderRating(value) {
  rating.dataset.value = value;
  rating.querySelectorAll('button').forEach((b) => {
    b.classList.toggle('on', parseInt(b.dataset.i, 10) <= value);
  });
  if (ratingLabel) ratingLabel.textContent = `${value} of 5 stars`;
}
renderRating(parseInt(rating.dataset.value, 10));
rating.addEventListener('click', (e) => {
  const btn = e.target.closest('button');
  if (!btn) return;
  e.stopPropagation();
  renderRating(parseInt(btn.dataset.i, 10));
});

// Loading button — toggle spinner for 1.6s
document.getElementById('loading-btn').addEventListener('click', (e) => {
  e.stopPropagation();
  const btn = e.currentTarget;
  if (btn.getAttribute('aria-busy') === 'true') return;
  const spinner = btn.querySelector('.btn-spinner');
  const label = btn.querySelector('span:not(.btn-spinner)');
  btn.setAttribute('aria-busy', 'true');
  spinner.hidden = false;
  const original = label.textContent;
  label.textContent = 'Saving…';
  setTimeout(() => {
    btn.setAttribute('aria-busy', 'false');
    spinner.hidden = true;
    label.textContent = original;
    showToast('Saved ✓', { variant: 'success' });
  }, 1600);
});

// Dropdown buttons (two — same target)
['dropdown-btn', 'open-dropdown-demo'].forEach((id) => {
  document.getElementById(id).addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    openMenu(e.currentTarget, [
      { label: 'Edit',     action: () => showToast('Edit') },
      { label: 'Duplicate', action: () => showToast('Duplicated') },
      { label: 'Archive',  action: () => showToast('Archived') },
      '-',
      { label: 'Delete',   action: () => showToast('Deleted', { variant: 'error' }) }
    ]);
  });
});

// Toast & modal demos
document.getElementById('show-toast-demo').addEventListener('click', (e) => {
  e.stopPropagation();
  showToast('Hello! This is a default toast.');
});
document.getElementById('show-toast-success').addEventListener('click', (e) => {
  e.stopPropagation();
  showToast('Saved successfully', { variant: 'success' });
});
document.getElementById('show-toast-error').addEventListener('click', (e) => {
  e.stopPropagation();
  showToast('Something went wrong', { variant: 'error' });
});
document.getElementById('open-modal-demo').addEventListener('click', (e) => {
  e.stopPropagation();
  showModal({
    title: 'Confirm action',
    body: '<p style="font-size:13px;color:var(--text-secondary);line-height:1.6;margin:0">Modals support <strong>any HTML</strong>, focus trap, click-outside dismiss, Escape to close, and reduced-motion preferences. Try Tab and Shift+Tab to see focus stay inside.</p>',
    actions: [
      { label: 'Cancel', variant: 'outline' },
      { label: 'Confirm', variant: 'primary', action: () => showToast('Confirmed', { variant: 'success' }) }
    ]
  });
});

// Drawer demo
const backdrop = document.getElementById('demo-drawer-backdrop');
const drawerRight = document.getElementById('demo-drawer-right');
const drawerLeft  = document.getElementById('demo-drawer-left');
const openDrawer = (drawer) => {
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  backdrop.classList.add('open');
};
const closeDrawer = () => {
  [drawerRight, drawerLeft].forEach((d) => { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); });
  backdrop.classList.remove('open');
};
document.getElementById('open-drawer-right').addEventListener('click', (e) => { e.stopPropagation(); openDrawer(drawerRight); });
document.getElementById('open-drawer-left').addEventListener('click',  (e) => { e.stopPropagation(); openDrawer(drawerLeft);  });
backdrop.addEventListener('click', closeDrawer);
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-drawer-close]')) closeDrawer();
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && (drawerRight.classList.contains('open') || drawerLeft.classList.contains('open'))) closeDrawer();
});

// Tag input + segmented inside drawers (lightweight)
document.querySelectorAll('.drawer .tag-input').forEach((wrap) => {
  const input = wrap.querySelector('input');
  wrap.addEventListener('click', (e) => {
    if (e.target === wrap) input.focus();
    const close = e.target.closest('.tag-pill button');
    if (close) close.closest('.tag-pill').remove();
  });
});
